import React from 'react'
import { localestr,beginMn,endMn, toText } from '../utils'
import Menu from '../cmp/menu'

function CatDevices4Viev({data,actions,setModal,ws,printer}){
    let wndData=''
    if(data) wndData=data
    const msg=actions.msg
    const inputRange=actions.inputRange
    const inputNumber=actions.inputNumber
    const loaddata=actions.loaddata
    //const addTWnd=context.addTWnd

    let from=new Date()
    from.setHours(0,0,0,0)
    let to=new Date()
    to.setHours(23,59,59,999)
    let rep_d=new Date()
    rep_d.setDate(rep_d.getDate()-5)

    const start_shift=(scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'StartShift',screen:scr,printer})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }
    
    const service_input=(sum,scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'ServiceInput',sum,screen:scr,printer})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }
    
    const service_output=(sum,scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'ServiceOutput',sum,screen:scr,printer})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }

    const x_report=(scr=false)=>{
        //console.log({id:wndData.id,command:'XReport',screen:scr})
        let dataJS=''
         dataJS=JSON.stringify({id:wndData.id,protocol: wndData.conection ?? '', command:'XReport',screen:scr,printer})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }

    const x_report_loc=(scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'XReportLoc',screen:scr,printer})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }

    const close_shift=(scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'CloseShift',screen:scr,printer})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }
    

    const close_shiftOnly=(scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'CloseShiftOnly',screen:scr,printer})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }
    
    const shifts_list=(d1,d2)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'ShiftsList',from:d1,to:d2})
        loaddata('action=rroCommand&data='+dataJS,undefined,(data)=>printing(data,localestr('Перелік змін')))
    }

    const docs_list=(d1,d2)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'DocsList',from:d1,to:d2})
        loaddata('action=rroCommand&data='+dataJS,undefined,(data)=>printing(data,localestr('Перелік документів')))
    }

    const zrep_copy=(num,scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'ZRepCopy',NumFiscal:num,screen:scr,printer})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }

    const check_copy=(num,scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'CheckCopy',NumFiscal:num,screen:scr,printer})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }

    const periodical_zrep=(d1,d2,scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'PeriodicalZRep',from:d1,to:d2,screen:scr,printer})
        loaddata('action=rroCommand&data='+dataJS,undefined,()=>{})
    }

    const status_on=(d)=>{
        if(d){
            msg(d.data.replace(/<br>/g,"\n"),localestr('Статус в ДФС'),[{caption:'OK',action:()=>{}}])
            return
        }
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'StatusOnline'})
        loaddata("action=rroCommand&data="+dataJS,undefined,status_on)
    }

    const status_of=(d)=>{
        if(d){
            msg(d.data.replace(/<br>/g,"\n"),localestr('Статус в пам\'яті'),[{caption:'OK',action:()=>{}}])
            return
        }
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'StatusOfline'})
        loaddata("action=rroCommand&data="+dataJS,undefined,status_of)
    }

    const terms=()=>{
        const str=localestr('Термін закінчення дії особистого ключа ')+toText(wndData.keyfile)+"\n"+localestr('Термін закінчення дії ліцензії на ПРРО ')+toText(wndData.licfile)
        msg(str,localestr('Інформація'),[{caption:'OK',action:()=>{}}])
    }

    /*/const cor_check=(d,scr)=>{
        if(d) {
            let data={id:wndData.id,pay_form:d.payType,sum_pay:0,screen:scr}
            if(parseInt(d.checkType)===0) data.command='PutCheck'
            else {
                data.command='PutReturn'
                data.check_num=d.retNum
            }
            const doc_tbl=d.list.map(el=>{return {goods_id:el.menu.id,goods:el.menu.name,uktz:el.uktz,unit:el.unit.name||'шт',qtt:parseFloat(el.sum_qtt),sum:parseFloat(el.sum_bruto),disc:parseFloat(el.sum_discount),vat:null,excise:el.excise,excise_mark:el.excise_mark}})
            data.doc_tbl=doc_tbl
            const dataJS=JSON.stringify(data)
            loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
        }
        //else addTWnd(localestr('Коригувальний чек'),'serv_check',(data)=>prn_req((p)=>cor_check(data,p)),{fiscal:wndData,checkType:'0',payType:'0',list:[]})
    }*/
    
    const printing=(data,caption)=>{
        if(data.status==='OKPrint'){
            if(!data.data) return
            const items=data.data.map((col,idx)=>{
                const rows=col.map((row,id)=>{
                    if(row.action) return <div key={idx+'_'+id} style={row.style} onDoubleClick={()=>specification(row.action)}>{row.text}</div>
                    else return <div key={idx+'_'+id} style={row.style}>{row.text}</div>
                })
                return <div key={idx} style={{display:'flex',flexDirection:'row'}}>{rows}</div>
            })
            const cont=<div style={{display:'flex',flexDirection:'column',width:'90mm'}}>{items}</div>
            msg(cont,caption,[])
        }
        //console.log(data)
    }

    const prn_req=(act)=>{
        if(!wndData.Printer_id) return act(true)
        msg(localestr('Куди вивести результат?'),localestr('Запитання'),[{caption:localestr('Екран'),action:()=>act(true)},{caption:localestr('Принтер'),action:()=>act()},{caption:localestr('Відмінити'),action:()=>{}}])
        //act(true)
    }

    const prn_req_z=(act)=>{
        msg(localestr('Ви дійсно бажаєте закрити зміну та сформувати Z звіт?'),localestr('Запитання'),[{caption:localestr('Так'),action:()=>prn_req(act)},{caption:localestr('Відмінити'),action:()=>{}}])
        //act(true)
    }

    const specification=(obj)=>{
        if(!obj) return
        if(obj.act==='ZRepCopy') prn_req((p)=>zrep_copy(obj.NumFiscal,p))
        if(obj.act==='CheckCopy') prn_req((p)=>check_copy(obj.NumFiscal,p))
        //else console.log(obj.act)
        //console.log(obj)
        //msg2(obj.act)
    }

    const menuData=[
        {name:localestr('Термін дії ключа/ліцензії'),action:terms},
        {name:localestr('Статус локальний'),action:()=>{status_of()}},
        {name:localestr('Статус онлайн'),action:()=>{status_on()}},
        {name:localestr('Денний Х звіт офлайн'),action:()=>prn_req(p=>x_report_loc(p))},
        {name:localestr('Закрити зміну'),action:()=>prn_req(p=>close_shiftOnly(p))},
        //{name:localestr('Службовий чек'),action:cor_check},
        //{name:localestr('Вийти з офлайн'),icon:'#hisBut',action:()=>{}},
        //{name:localestr('Перенумерувати пакет'),icon:'#hisBut',action:()=>{}},
        //{name:localestr('Перейти в офлайн'),icon:'#hisBut',action:()=>{}},
    ]

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    function dragMouseDown(e) {
        e = e || window.event;
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
    }
      
    function elementDrag(e) {
        const elmnt=document.getElementById('catDevices4')
        e = e || window.event;
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        if (pos2!==0) elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
        if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }
      
    function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
    }
      
    //---термінал
    function clear_msg(msg){
        if (!msg) return ''
        let str=msg
        str = str.replace(/<div\b[^>]*>(.*?)<\/div>/g, ' $1 ')
        str = str.replace(/<div\b[^>]*>(.*?)<\/div>/g, ' $1 ')
        str = str.replace(/<div\b[^>]*>(.*?)<\/div>/g, ' $1 ')
        str = str.replace(/<div\b[^>]*>(.*?)<\/div>/g, ' $1 ')
        str = str.replace(/<br\/>/g, "\n")
        str = str.replace(/ {5,10}/g, "\n")
        str = str.replace(/ {2,10}/g, ' ')
        str = str.replace(/\n{2,10}/g, "\n")
        return str
    }

    function obj_to_str(obj){
        let str=''
        for (const [key, value] of Object.entries(obj)) {
            str+="\n"+key+' - '+value
        }
        return str
    }

    function ws_resp(d){
        if ( d['status'] === 'ok') {
            if(d['method'] === 'ServiceMessage') {
                if(d['response']['msgType']==='getMerchantList') msg(obj_to_str(d['response']),localestr('Повідомлення'),[{caption:'OK',action:()=>{}}])
                else msg(d['response']['msgType'],localestr('Повідомлення'),[{caption:'OK',action:()=>{}}])
            }
            if(d['method'] === 'Audit') msg(clear_msg(d?.['response']?.['receipt']),localestr('Повідомлення'),[{caption:'OK',action:()=>{}}])
            if(d['method'] === 'CheckConnection'){
                if(d['error']) msg(d['errorDescription'],localestr('Помилка'),[{caption:'OK',action:()=>{}}])
                else msg(localestr('З\'єднання встановлено успішно!'),localestr('Повідомлення'),[{caption:'OK',action:()=>{}}])
            } 
        } else if (d['status'] === 'error')  msg(d['message'],localestr('Помилка'),[{caption:'OK',action:()=>{}}])
    }
    
    function ws_open() {
        if(ws) {
            return
        }
        ws=(new WebSocket("ws://"+wndData.ip+":"+wndData.port+"/echo"))
        ws.onopen = function() {}
        ws.onclose = function(evt) {
            ws = null
        }
        ws.onmessage = function(evt) {
            ws_resp(JSON.parse(evt.data));
        }
        ws.onerror = function(evt) {
            console.log("ERROR: " + evt.data)
        }
    }
        
    function ws_close() {
        if(!ws) {
            return false
        }
        ws.close(1000)
        return false
    }
    
    function check_con(cnt=0){
        ws_open()
        if(!ws){
            msg(localestr('Відсутнє з\'єднання!'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        if(ws.readyState!==1&&cnt>10){
            msg(localestr('Відсутнє з\'єднання!'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        if(ws.readyState!==1){
            setTimeout(()=>check_con(cnt+1),300)
            return
        }
        let j = JSON.stringify({
            method: 'CheckConnection',
            step: 0,
            params: {
                groupId: wndData.groupId ?? null,
                groupList: wndData.terminalGroups
            }
        })
        ws.send(j)
        //setTimeout(ws_close,15000)
    }

     function x_balance(cnt=0){
        ws_open()
        if(!ws){
            msg(localestr('Відсутнє з\'єднання!'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        if(ws.readyState!==1&&cnt>10){
            msg(localestr('Відсутнє з\'єднання!'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        if(ws.readyState!==1){
            setTimeout(()=>x_balance(cnt+1),300)
            return
        }
        let j = JSON.stringify({
            method: 'XReport',
            step: 0,
            params: {
                groupId: wndData.groupId ?? null,
                groupList: wndData.terminalGroups
            }
        })
        ws.send(j)
        setTimeout(ws_close,15000)
    }

    function merch_list(cnt=0){
        ws_open()
        if(!ws){
            msg(localestr('Відсутнє з\'єднання!'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        if(ws.readyState!==1&&cnt>10){
            msg(localestr('Відсутнє з\'єднання!'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        if(ws.readyState!==1){
            setTimeout(()=>merch_list(cnt+1),300)
            return
        }
        let j = JSON.stringify({
            method: 'MerchantList',
            step: 0,
            params: {
                msgType: 'getMerchantList',
                groupId: wndData.groupId ?? null,
                groupList: wndData.terminalGroups
            }
        })
        ws.send(j)
        setTimeout(ws_close,15000)
    }
    
    let terminal=null
     if(wndData.ip && wndData.port){
        let menuTerm =[
                    {name:localestr('Перевірка звязку з банком'),action:()=>{check_con()}},
                    {name:localestr('Х баланс'),action:()=>x_balance()},
                    {name:localestr('Список доступних компаній '),action:()=>{merch_list()}},
                ];
        terminal=<div style={{width:'244px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'}><div style={{height:'30px',lineHeight:'30px',display:'block'}}><Menu stl={{height:'unset',position:'absolute',width:'calc(100% - 18px)'}} data={menuTerm} left={true}>{localestr('Платіжний термінал')}</Menu></div></div>
    }

    return(
        <div className='modal'><div id='catDevices4' className='window' style={{width:'260px'}}>
            <div onMouseDown={dragMouseDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{localestr('ПРРО')+' '+wndData.name}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
        <div className='content'>
        <div className='no-print' style={{display:'flex',flexDirection:'column'}}>
        <div style={{margin:'2px 0',display:'inherit'}}>
        <div style={{width:'244px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>prn_req(p=>start_shift(p))}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Відкрити зміну')}</div></div>
        </div><div style={{margin:'2px 0',display:'inherit'}}>
        <div style={{width:'119px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>inputNumber(localestr('Введіть суму'),localestr('Сума'),0,s=>prn_req(p=>service_input(s,p)))}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Внесення')}</div></div>
        <div style={{width:'119px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>inputNumber(localestr('Введіть суму'),localestr('Сума'),0,s=>prn_req(p=>service_output(s,p)))}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Видача')}</div></div>
        </div><div style={{margin:'2px 0',display:'inherit'}}>
        <div style={{width:'244px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>prn_req(p=>x_report(p))}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Денний Х звіт')}</div></div>
        </div><div style={{margin:'2px 0',display:'inherit'}}>
        <div style={{width:'244px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>prn_req_z(p=>close_shift(p))}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Фіскальний Z звіт')}</div></div>
        </div><div style={{margin:'2px 0',display:'inherit'}}>
        <div style={{width:'119px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{inputRange(from,to,shifts_list)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Реєстр змін')}</div></div>
        <div style={{width:'119px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{inputRange(from,to,docs_list)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Реєстр чеків')}</div></div>
        </div><div style={{margin:'2px 0',display:'inherit'}}>
        <div style={{width:'244px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{inputRange(beginMn(rep_d),endMn(rep_d),(d1,d2)=>prn_req(p=>periodical_zrep(d1,d2,p)))}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Періодичний звіт')}</div></div>
        </div><div style={{margin:'2px 0',display:'inherit'}}>
        <div style={{width:'244px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'}><div style={{height:'30px',lineHeight:'30px',display:'block'}}><Menu stl={{height:'unset',position:'absolute',width:'calc(100% - 18px)'}} data={menuData} left={true}>{localestr('Додатково')}</Menu></div></div>
        </div></div>
        {terminal}
        </div></div></div>
    )

}

export default CatDevices4Viev